import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedNode: null,
  domainDn: null,
  domainName: null,
  typeOfData: null,
  currentdomainId: null,
  pageNumber: 1,
  pageSize: 20,
  searchQuery: '',
  isDescending: false,
  sortType: '',
  usersFilter: 'all',
};

const selectedNodeSlice = createSlice({
  name: 'selectedNode',
  initialState,
  reducers: {
    setSelectedNode: (state, action) => {
      state.selectedNode = action.payload;
    },
    setDomainName: (state, action) => {
      state.domainName = action.payload;
    },
    setDomainDn: (state, action) => {
      state.domainDn = action.payload;
    },
    setDomainId: (state, action) => {
      state.currentdomainId = Number(action.payload);
    },
    setTypeOfData: (state, action) => {
      state.typeOfData = action.payload;
    },
    setPageNumber: (state, action) => {
      state.pageNumber = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
    },
    setIsDescending: (state, action) => {
      state.isDescending = action.payload;
    },
    setSortType: (state, action) => {
      state.sortType = action.payload;
    },
    setUsersFilter: (state, action) => {
      state.usersFilter = action.payload;
    },
    resetDomainState: (state) => {
      return initialState; // Use initialState to reset the state
    },
    resetUsers: (state) => {
      state.pageNumber = 1;
      state.pageSize = 20;
      state.searchQuery = '';
      state.isDescending = false;
      state.sortType = '';
    },
  },
});

export const {
  setSelectedNode,
  setDomainDn,
  setDomainName,
  setDomainId,
  setTypeOfData,
  resetDomainState,
  setPageNumber,
  setPageSize,
  setSearchQuery,
  setIsDescending,
  setSortType,
  setUsersFilter,
  resetUsers,
} = selectedNodeSlice.actions;
export default selectedNodeSlice.reducer;
